import AOS from 'aos';
if (document.querySelectorAll('.module-service-filter').length > 0) {
    document.addEventListener("DOMContentLoaded", function () {
        const filtername = document.getElementById("filtername");
        const checkboxes = document.querySelectorAll(".filter-checkbox");
        const sections = document.querySelectorAll(".filter-section");
        const subsections = document.querySelectorAll(".filter-subsection");
        const items = document.querySelectorAll(".item");

        function filterItems() {
            const nameValue = filtername.value.trim().toLowerCase();

            let selectedFilters = {
                zone: [],
                section: [],
                subsection: []
            };

            checkboxes.forEach(checkbox => {
                if (checkbox.checked) {
                    selectedFilters[checkbox.dataset.filter].push(checkbox.value);
                }
            });


            items.forEach(item => {
                const textMatch = nameValue ? item.dataset.text.toLowerCase().indexOf(nameValue) > -1 : true;
                if (textMatch) {
                    console.log("test");
                }
                const itemZones = item.dataset.zone ? item.dataset.zone.split(",") : [];
                const itemSections = item.dataset.section ? item.dataset.section.split(",") : [];
                const itemSubsections = item.dataset.subsection ? item.dataset.subsection.split(",") : [];

                const zoneMatch = selectedFilters.zone.length === 0 || selectedFilters.zone.some(value => itemZones.includes(value));
                const sectionMatch = selectedFilters.section.length === 0 || selectedFilters.section.some(value => itemSections.includes(value));
                const subsectionMatch = selectedFilters.subsection.length === 0 || selectedFilters.subsection.some(value => itemSubsections.includes(value));


                item.style.display = (textMatch && zoneMatch && sectionMatch && subsectionMatch) ? "" : "none";
            });

            setTimeout(function () {
                subsections.forEach(subsection => {
                    const visibleItems = subsection.querySelectorAll(".item:not([style*='display: none'])");
                    subsection.style.display = visibleItems.length > 0 ? "" : "none";
                });

                // Versteckt leere Sections
                sections.forEach(section => {
                    const visibleSubsections = section.querySelectorAll(".item:not([style*='display: none'])");
                    section.style.display = visibleSubsections.length > 0 ? "" : "none";
                });

                AOS.refresh();
            }
                , 100);
            // Versteckt leere Subsections

        }

        filtername.addEventListener("input", filterItems);
        checkboxes.forEach(checkbox => checkbox.addEventListener("change", filterItems));
    });
}